// extracted by mini-css-extract-plugin
export default {"successPage":"R17R2y","successCard":"niMgl3","successTitle":"wNIdfN","successText":"rHqKKt"};